<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <!-- 国家筛选 start -->
          <el-select
            v-if="typeof constDict.country_list === 'object'"
            v-model="countryId"
            title="选择国家"
            filterable>
            <el-option
              v-for="(option, index) in constDict.country_list"
              :key="index"
              :label="option"
              :value="index"/>
          </el-select>
          <!-- 国家筛选 end -->
          <!-- 看板数字 start -->
          <el-row
            v-loading="!numbers.length"
            class="rows row-numbers"
            :gutter="10">
            <el-col
              v-for="(option, index) in numbers"
              :class="`number${index}`"
              :key="index"
              :xs="24"
              :sm="24"
              :md="24"
              :lg="8">
              <div class="rows-div">
                <p><span class="s_title">{{ option.title }}</span> <span class="s_right">{{ option.date_title }}</span></p>
                <el-row class="r-number">
                  <el-col
                    class="v-number"
                    v-if="option.list && option.list.length"
                    v-for="(v, k) in option.list"
                    :key="k"
                    :span="8">
                    <span>{{ v.title }}</span>
                    <b>{{ v.number }}<i v-html="k === 1 ? '条' : '单'"/></b>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <!-- 看板数字 end -->
          <el-row
            class="rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">签约趋势</span>
                  <el-tooltip
                    placement="right"
                    effect="light">
                    <div slot="content">
                      注册量：注册时间为当前日期的资源数<br>
                      当期签约量：注册时间为当前日期的签约资源数<br>
                      实际签约量：签约时间为当前日期的签约资源数
                    </div>
                    <i class="el-icon-question blue"/>
                  </el-tooltip>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date4"
                      slot="head"
                      v-model="signType"
                      size="mini"
                      @change="getSignData">
                      <el-radio-button
                        v-for="(option, index) in constDict.date4"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-line
                    :data="signData.data"
                    :options="signData.options"
                    :refresh="signData.refresh"
                    @reload="getSignData"/>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">资源占比统计</span>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date4"
                      slot="head"
                      v-model="signChannelType"
                      size="mini"
                      @change="getSignChannelData">
                      <el-radio-button
                        v-for="(option, index) in constDict.date4"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-d-pie
                    :data="signChannelData.data"
                    :options="signChannelData.options"
                    :refresh="signChannelData.refresh"
                    @reload="getSignChannelData"/>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="rows"
            :gutter="10">
            <el-col :span="24">
              <div class="rows-div">
                <p>
                  <span class="s_title">渠道转化</span>
                  <el-tooltip
                    placement="top"
                    effect="light">
                    <div slot="content">
                      数据量过多时，可以使用鼠标左右拖动下方数据区域
                    </div>
                    <span><i class="el-icon-caret-left blue"/><i class="el-icon-caret-right blue"/></span>
                  </el-tooltip>
                  <el-tooltip
                    placement="right"
                    effect="light">
                    <div slot="content">
                      注册量：注册时间为当前日期的资源数<br>
                      当期签约量：注册时间为当前日期的签约资源数<br>
                      实际签约量：签约时间为当前日期的签约资源数
                    </div>
                    <i class="el-icon-question blue"/>
                  </el-tooltip>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date4"
                      slot="head"
                      v-model="channelType"
                      size="mini"
                      @change="getChannelData">
                      <el-radio-button
                        v-for="(option, index) in constDict.date4"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                  <span
                    class="s_right"
                    v-if="channelSort.options.length">排序方式：
                    <el-select
                      v-model="channelSort.value"
                      placeholder="请选择排序方式"
                      size="mini"
                      class="jm-input135"
                      @change="setChannelSort">
                      <el-option
                        v-for="item in channelSort.options"
                        :key="item"
                        :label="item"
                        :value="item"/>
                    </el-select>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-bar-line
                    :data="channelData.data"
                    :data1="channelData.data1"
                    :options="channelData.options"
                    :refresh="channelData.refresh"
                    @reload="getChannelData"/>
                </div>
                <!--
                <div class="chart-div">
                  <bi-point-line :data="channelData.data" :data1="channelData.data1" :options="channelData.options" :refresh="channelData.refresh" @reload="getChannelData"></bi-point-line>
                </div>
-->
              </div>
            </el-col>
          </el-row>
          <el-row
            class="rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">客户分级</span>
                  <span class="s_right">入学时间：
                    <el-select
                      class="jm-input90"
                      v-if="constDict.year"
                      slot="head"
                      v-model="levelYear"
                      size="mini"
                      @change="getLevelYear">
                      <el-option
                        v-for="(option, index) in constDict.year"
                        :key="index"
                        :label="option"
                        :value="index"/>
                    </el-select>
                    <el-select
                      class="jm-input90"
                      v-if="constDict.month"
                      slot="head"
                      v-model="levelMonth"
                      size="mini"
                      @change="getLevelMonth">
                      <el-option
                        v-for="(option, index) in constDict.month"
                        :key="index"
                        :label="option"
                        :value="index"/>
                    </el-select>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-d-pie
                    :data="levelData.data"
                    :child-data="levelData.childData"
                    :options="levelData.options"
                    :refresh="levelData.refresh"
                    @reload="getLevelData"/>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">办理进度</span>
                  <span class="s_right">入学时间：
                    <el-select
                      class="jm-input90"
                      v-if="constDict.year"
                      slot="head"
                      v-model="processYear"
                      size="mini"
                      @change="getProcessYear">
                      <el-option
                        v-for="(option, index) in constDict.year"
                        :key="index"
                        :label="option"
                        :value="index"/>
                    </el-select>
                    <el-select
                      class="jm-input90"
                      v-if="constDict.month"
                      slot="head"
                      v-model="processMonth"
                      size="mini"
                      @change="getProcessMonth">
                      <el-option
                        v-for="(option, index) in constDict.month"
                        :key="index"
                        :label="option"
                        :value="index"/>
                    </el-select>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-bar
                    :data="processData.data"
                    :options="processData.options"
                    :refresh="processData.refresh"
                    @reload="getProcessData"/>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">签约-小程序</span>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date3"
                      slot="head"
                      v-model="productType"
                      size="mini"
                      @change="getSignProductData">
                      <el-radio-button
                        v-for="(option, index) in constDict.date3"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-bar
                    :data="signProductData.data"
                    :options="signProductData.options"
                    :refresh="signProductData.refresh"
                    @reload="getSignProductData"/>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">签约-回访</span>
                  <el-tooltip
                    placement="top"
                    effect="light">
                    <div slot="content">
                      数据量过多时，可以使用鼠标左右拖动下方数据区域
                    </div>
                    <span><i class="el-icon-caret-left blue"/><i class="el-icon-caret-right blue"/></span>
                  </el-tooltip>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date3"
                      slot="head"
                      v-model="returnType"
                      size="mini"
                      @change="getSignReturnData">
                      <el-radio-button
                        v-for="(option, index) in constDict.date3"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-bar-line
                    :data="signReturnData.data"
                    :data1="signReturnData.data1"
                    :options="signReturnData.options"
                    :refresh="signReturnData.refresh"
                    @reload="getSignReturnData"/>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiDPie from '@/components/charts/biDPie';
import BiLine from '@/components/charts/biLine';
import BiBar from '@/components/charts/biBar';
import BiBarLine from '@/components/charts/biBarLine';
import BiPointLine from '@/components/charts/biPointLine';
import common from '@/pages/bi/common';

let constDict = {
  country_list: {},
  date4: {},
  date3: {},
  year: ['全部'],
  month: ['全部', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      countryId: 0,
      signType: 3,
      signChannelType: 3,
      channelType: 3,
      levelYear: 0,
      levelMonth: 0,
      processYear: 0,
      processMonth: 0,
      productType: 2,
      returnType: 2,
      signData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      signChannelData: {
        refresh: 1
      },
      channelData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      channelSort: {
        options: [],
        value: '注册量'
      },
      levelData: {
        refresh: 1
      },
      processData: {
        refresh: 1
      },
      signProductData: {
        refresh: 1
      },
      signReturnData: {
        refresh: 1
      },
      numbers: []
    };
  },
  components: {
    BiLine, BiDPie, BiBar, BiBarLine, BiPointLine
  },
  created() {
    this.$http
      ._get({
        url: '/index/b_i_busi_main/index'
      })
      .then(({ data }) => {
        if (typeof data.country_list === 'object') {
          this.constDict.country_list = data.country_list;
          this.countryId = Object.keys(data.country_list)[0];
        } else {
          this.countryId = data.country_list;
        }
        this.constDict.date4 = data.date4;
        this.constDict.date3 = data.date3;
        this.constDict.year = data.year;
      });
  },
  methods: {
    init() {
      this.initNumber();
      this.getSignData();
      this.getSignChannelData();
      this.getChannelData();
      this.getLevelData();
      this.getProcessData();
      this.getSignProductData();
      this.getSignReturnData();
    },
    initNumber() {
      this.numbers = [];
      this.$http
        ._post({
          url: '/index/b_i_busi_main/initnumber',
          data: { country_id: this.countryId }
        })
        .then(({ data }) => {
          this.numbers = data;
        });
    },
    // 签约趋势
    getSignData() {
      this.fetchData({
        url: '/index/b_i_busi_main/initsigndata',
        field: 'signData',
        param: { country_id: this.countryId, date_type: this.signType },
        option: {
          margin: {
            top: 30, right: 24, bottom: 20, left: 30
          },
          labelWidthPercent: 100 / 6,
          colors: ['#409EFF', '#BD48FF', '#FF9F00'],
          domainType: 'time',
          tooltipType: 'day'
        }
      });
    },
    // 签约资源
    getSignChannelData() {
      this.fetchData({
        url: '/index/b_i_busi_main/initsignchannel',
        field: 'signChannelData',
        param: { country_id: this.countryId, date_type: this.signChannelType },
        option: {
          margin: {
            top: 50, right: 100, bottom: 20, left: 30
          },
          colors: [
            '#409EFF', '#BD48FF', '#FF9F00', '#FF6153', '#01E2FF', '#FF90A8',
            '#00E9A8', '#F83458', '#8103FF', '#65F9E3', '#FFC800', '#273EF0',
            '#F7B3F6'
          ],
          labelWidthPercent: 100 / 6,
          init: true
        }
      });
    },
    // 渠道转化
    getChannelData() {
      this.fetchData({
        url: '/index/b_i_busi_main/initchannel',
        field: 'channelData',
        param: { country_id: this.countryId, date_type: this.channelType },
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 0
          },
          labelWidthPercent: 100 / 12,
          colors: ['#409EFF', '#BD48FF', '#FF9F00', '#FF6153'],
          barWidth: '30',
          domainType: 'string',
          groupType: true,
          exY1: '%'
        },
        sort: 'channelSort'
      });
    },
    setChannelSort() {
      this.channelData = this.sortData(this.channelData, this.channelSort.value);
    },
    // 客户分级
    getLevelYear() {
      this.getLevelData();
    },
    getLevelMonth() {
      this.getLevelData();
    },
    getLevelData() {
      this.fetchData({
        url: '/index/b_i_busi_main/initlevel',
        field: 'levelData',
        param: { country_id: this.countryId, year: this.levelYear, month: this.levelMonth },
        option: {
          margin: {
            top: 50, right: 70, bottom: 20, left: 30
          },
          labelWidthPercent: 100 / 6,
          colors: [
            '#409EFF', '#BD48FF', '#FF9F00', '#FF6153', '#01E2FF', '#FF90A8',
            '#00E9A8', '#F83458', '#8103FF', '#65F9E3', '#FFC800', '#273EF0',
            '#F7B3F6'
          ],
          exTitle: '老师占比',
          init: true
        }
      });
    },
    // 办理进度
    getProcessYear() {
      this.getProcessData();
    },
    getProcessMonth() {
      this.getProcessData();
    },
    getProcessData() {
      let countryList = ['30', '31', '83'];
      if (countryList.indexOf(this.countryId) === -1) {
        let error = '数据建设中，请耐心等待...';
        this.processData = {
          data: [],
          options: {
            error
          },
          refresh: 2
        };
      } else {
        this.fetchData({
          url: '/index/b_i_busi_main/initprocess',
          field: 'processData',
          param: { country_id: this.countryId, year: this.processYear, month: this.processMonth },
          option: {
            barWidth: '40',
            colors: ['#409EFF', '#FF6153', '#FF9F00'],
            domainType: 'string',
            groupType: true
          }
        });
      }
    },
    // 签约-小程序
    getSignProductData() {
      this.fetchData({
        url: '/index/b_i_busi_main/product',
        field: 'signProductData',
        param: { country_id: this.countryId, date_type: this.productType },
        option: {
          margin: {
            top: 30, right: 24, bottom: 20, left: 50
          },
          labelWidthPercent: 100 / 6,
          colors: ['#409EFF', '#FF6153'],
          barWidth: '40',
          domainType: 'string',
          groupType: true,
          exLabel: '小程序%%'
        }
      });
    },
    // 签约-回访
    getSignReturnData() {
      this.fetchData({
        url: '/index/b_i_busi_main/returndata',
        field: 'signReturnData',
        param: { country_id: this.countryId, date_type: this.returnType },
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 0
          },
          labelWidthPercent: 100 / 6,
          colors: ['#409EFF', '#FF6153', '#BD48FF'],
          barWidth: '40',
          domainType: 'string',
          groupType: true,
          exLabel: '回访%%',
          exY1: '%'
        }
      });
    }
  },
  watch: {
    countryId() {
      this.$nextTick(this.init);
    }
  }
};
</script>

<style scoped>

.s_right {
  float: right;
  margin-left: 24px;
}

.rows:last-child {
  margin-bottom: 200px;
}

.rows .rows-div {
  background-color: #FFF;
  border-radius: 5px;
  margin-top: 10px;
  padding: 10px 20px 20px 20px;
}

.rows .rows-div p {
  border-bottom: solid 1px #CCC;
  padding: 10px 0px;
}

.rows .rows-div .chart-div {
  height: 250px;
}

.s_title {
  font-size: 18px;
}

.rows.row-numbers .rows-div {
  height: 150px;
  color: #FFF;
  padding: 0;
}

.rows.row-numbers .number0 .rows-div {
  background: linear-gradient(#6255FF, #5D85FF);
}

.rows.row-numbers .number1 .rows-div {
  background: linear-gradient(#0089FF, #59D6FF);
}

.rows.row-numbers .number2 .rows-div {
  background: linear-gradient(#0058FF, #7FA9FF);
}

.rows.row-numbers p{
  background-color:#FFF;
  background-color:rgba(255,255,255,0.1);
  border: none;
  padding: 10px 20px;
}

.r-number {
  padding: 13px;
}

.v-number span {
  text-align: center;
  margin-top: 5px;
  display: block;
}

.v-number b {
  font-size: 25px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 5px;
  display: block;
}

.v-number i {
  font-size: 14px;
  font-weight: normal;
  text-align: center;
}

.v-number:nth-child(2) {
  border-left: rgba(255,255,255,0.3) 1px solid;
  border-right: rgba(255,255,255,0.3) 1px solid;
}

.blue {
  color: #409EFF;
}
</style>
